export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Geología — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre rocas ígneas, sedimentarias y metamórficas. Antes yo mismo perdía tiempo buscando cómo explicar correctamente cómo se forman. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesora de Geología — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar la tectónica de placas o cómo se originan los terremotos. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Geología — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos integradores están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Geología | Lima, Perú',
    'El material sobre minerales y rocas le cambió la cara a mis alumnos. Por fin entienden cómo identificar una roca y qué tipo es. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Geología | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Geología | Caracas, Venezuela',
    'Los 100 casos problemáticos transformaron a los alumnos que no entendían tectónica de placas y terremotos. Ahora analizan paso a paso cómo se origina un sismo y lo aplican solos. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'Las 60 prácticas de laboratorio me devolvieron el tiempo de clase. Antes perdía mucho tiempo armando actividades. Ahora tengo todo listo, seguro y accesible. Mis alumnos pueden hacer verdadera geología.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Geología | Quito, Ecuador',
    'Los 200 conceptos explicados fueron una revelación. Mis alumnos finalmente entienden para qué es todo esto. Analizan fósiles en sus propias regiones, identifican rocas en el campo. Eso cambió completamente su relación con la geología.',
  ],
];
